<template>
    <el-drawer
        :before-close="cancel"
        :title="`${tname}  佐证材料`"
        :visible.sync="dialogVisible"
        :wrapperClosable="true"
        append-to-body
        center
        class="dialog-container flex flex-direction"
        direction="rtl"
        size="700px">
        <div class="dialog-content flex flex-direction padding-lr-sm flex-sub">
            <div class="flex align-center">
                <div class="text-black text-df"><i class="iconfont icon-vertical_line text-black text-bold text-df"></i>{{ pname }}</div>
            </div>
            <div class="document radius margin-top-sm">
                <div class="flex align-center justify-between padding-sm">
                    <div class="text-lg text-black text-bold"><i class="iconfont icon-24gf-folderOpen text-xl margin-right-xs"></i>{{ fname }}</div>
<!--                    <el-upload-->
<!--                        class="margin-lr-xs"-->
<!--                        :action="FILE_UPLOAD_HOST"-->
<!--                        :before-upload="beforeAvatarUpload"-->
<!--                        :data="QNData"-->
<!--                        :on-error="uploadError"-->
<!--                        :on-success="uploadSuccess" :show-file-list="false" v-if="!readonly">-->
<!--                        <el-button class="btn small radius" type="primary" size="small">上传</el-button>-->
<!--                    </el-upload>-->
                    <upload-file class="margin-lr-xs" @uploadFile="uploadFile" :disabled="readonly">
                        <el-button slot="upload" class="btn small radius" size="small" type="primary">上传</el-button>
                    </upload-file>
                </div>
                <el-divider v-if="lists.length"></el-divider>
                <div class="files flex flex-direction padding-tb-sm margin-right-sm margin-left-xl" v-for="(item,index) in lists" :key="index">
                    <div class="flex align-center justify-between">
                        <div class="file-name title text-sm" :href="item.file_url" target="_blank" @click="toFilePreview(item.file_name,item.file_url)">{{item.file_name}}</div>
                        <el-button class="el-icon-delete text-orange" type="text" @click="delFile(item)" v-if="!readonly"></el-button>
                    </div>
                    <div class="flex align-center">
                        <div class="text-xs text-gray">{{item.name}}</div>
                        <div class="text-xs text-gray margin-left-sm">{{item.create_time}}</div>
                    </div>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { addTaskFolderFile, delTaskFolderFile, getEnclosureByFolderId} from "@/api";
import {confirm, TOAST, toast, toFilePreview} from "@/utils/utils";
import UploadFile from "@/views/web/components/UploadFile";

export default {
    name: "TaskFolderDialog",
    components: {UploadFile},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: true
        },
        fid: { //文件夹id
            type: Number,
        },
        tname: { //任务名
            type: String,
        },
        fname: { //文件夹名字
            type: String,
        },
        pname: { //项目名称
            type: String,
        }
    },
    data() {
        return {
           lists:[]
        }
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            if (this.fid) {
                let _data = await getEnclosureByFolderId(this.fid)
                this.lists = _data.data
            }
        },
        delFile(item){
            confirm(`删除文件`,`你确定删除<b>${item.file_name}</b>文件吗？`,()=>{
                this.delFileItem(item.id)
            },'确认',true)
        },
        async delFileItem(id){
            let _data = await delTaskFolderFile(id)
            if (_data.status === 200) {
                toast(`删除成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        //  上传成功
        uploadFile(data) {
            this.upFile(data.file.url,data.file.name)
        },
        async upFile(url,name){
            let _data = await addTaskFolderFile(this.fid,url,name)
            if (_data.status === 200) {
                toast(`上传成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        },
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {

    },
    watch: {
        fid() {
            this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-container {
    .document {
        border: solid 1px #e6e6e6;

        .files + .files{
            border-top: solid 1px #e6e6e6;
        }
        .title {
            position: relative;

            &::before {
                position: absolute;
                content: '';
                width: 9px;
                height: 9px;
                border-radius: 9px;
                background-color: var(--orange);
                left: -20px;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
}

</style>